import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import GetHighlightedText from 'Utils/GetHighlightedText'
import JsonToQuery from 'Utils/JsonToQuery'

function SuggestionRow({
  query,
  result,
  thumbnailUrl,
  eventSource = '',
  className = '',
}) {
  function trackSuggestionClick() {
    if (query.length > 0 && window.trackSuggestionClick) {
      window.trackSuggestionClick({ value: result, searchTerm: query, eventSource })
    }
  }

  return (
    <a
      href={`/search?${JsonToQuery({ keywords: result, suggested: 1 })}`}
      className={classnames('unified-nav__suggestion', className)}
      onClick={trackSuggestionClick}
    >
      <img className="unified-nav__suggestion-image" src={thumbnailUrl} width={50} height={37} alt="" />
      {GetHighlightedText(result, query)}
    </a>
  )
}

SuggestionRow.propTypes = {
  query: string.isRequired,
  result: string.isRequired,
  thumbnailUrl: string.isRequired,
  eventSource: string,
  className: string,
}

export default memo(SuggestionRow)
